import { Controller } from "@hotwired/stimulus"
import { digits, formatRupiah } from "../lib/currency"

// UI-07: the visible field shows "Rp 1.500.000"; the hidden field submits 1500000.
export default class extends Controller {
  static targets = ["display", "value"]

  connect() {
    const stored = this.valueTarget.value ? String(Math.round(Number(this.valueTarget.value))) : ""
    this.displayTarget.value = formatRupiah(stored)
  }

  // Typing replaces the whole amount.
  select() {
    this.displayTarget.select()
  }

  format() {
    const raw = digits(this.displayTarget.value)
    this.valueTarget.value = raw
    this.displayTarget.value = formatRupiah(raw)
  }
}
